import Wow from 'wow.js'
import smoothscroll from 'smoothscroll-polyfill'
import {
    initAccordion,
    initAutoSlider,
    revealLinksOnAction
} from '../_modules/helpers'
import { handleRefsUs, REFS_US } from '@studybay/common-client-library/ref-handle'
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking';
import { sendGtmWithRedirect } from '@studybay/common-client-library/analytics/dataLayer';

function setRegUrl() {
    const href = document.location.origin + document.location.pathname;

    document.querySelectorAll('[data-form="signup-form"], [data-form="popup-signup"]').forEach(function(element) {
        element.querySelector('[name="reg_url"]').value = href
    })
}

function handleSideMenu() {
    const sideMenu = document.getElementById('side-menu')
    const closeElements = sideMenu.querySelectorAll('[data-side-menu="close"], [href="#author-reg-form"]')
    const openSideMenu = document.querySelector('[data-side-menu="open"]')

    openSideMenu.addEventListener('click', () => {
        sideMenu.hidden = false
        document.body.style.overflow = 'hidden'
    })

    closeElements.forEach(closeElement => {
        closeElement.addEventListener('click', () => {
            sideMenu.hidden = true
            document.body.style.overflow = 'initial'
        })
    })
}

const initWindowSlider = ({slider, changeTime=3000}={}) => {
    const root = slider.querySelector('[data-window-slider="root"]')
    const moveLeftButton = slider.querySelector('[data-window-slider-control="left"]')
    const moveRightButton = slider.querySelector('[data-window-slider-control="right"]')
    const items = Array.from(root.querySelectorAll('[data-window-slider="item"]'))
    const itemsNumber = items.length
    let activeIndex = 0
    let timerId = null

    const slide = () => {
        const width = root.clientWidth + 'px'
        root.style.minWidth = `min(${width}, 100%)`
        items.forEach(item => item.style.minWidth = `min(${width}, 100%)`)

        if (activeIndex >= itemsNumber) activeIndex = 0

        const activeItem = items[activeIndex]

        const rootOffset = Math.round(root.getBoundingClientRect().left)
        const itemOffset = activeItem.offsetLeft
        const moveTo = itemOffset - (activeIndex === 0 ? rootOffset : 0)

        root.scroll({left: moveTo, behavior: 'smooth'})
        activeIndex++
    }

    const autoSlide = () => {
        slide()
        timerId = setInterval(slide, changeTime)
    }

    const mql = window.matchMedia('(max-width: 800px)')
    const mediaHandler = () => {
        const width = root.clientWidth + 'px'
        root.style.minWidth = `min(${width}, 100%)`
        items.forEach(item => item.style.minWidth = `min(${width}, 100%)`)
    }

    if (mql.addListener) mql.addListener(mediaHandler)
    else mql.addEventListener('change', mediaHandler)

    moveLeftButton.addEventListener('click', () => {
        clearInterval(timerId)
        activeIndex-=2
        if (activeIndex < 0) activeIndex = itemsNumber - 1
        autoSlide()
    })

    moveRightButton.addEventListener('click', () => {
        clearInterval(timerId)
        autoSlide()
    })

    autoSlide()
}

const sendLoginEvent = () => {
    sendGtmWithRedirect('Click_Login', '/login/', {
        'page_url': window.location.href,
    })
  }

function init() {
    smoothscroll.polyfill()
    const loginLinks = document.querySelectorAll('[data-login-link]')

    initWindowSlider({
        slider: document.getElementById('slideThis'),
        changeTime: 4000,
    })

    initAutoSlider({slider: document.getElementById('popular-slider')})

    new Wow().init();

    setRegUrl()
    handleSideMenu()
    initAccordion(document.querySelector('.accordion-list'))
    revealLinksOnAction(() => {
        handleRefsUs(REFS_US.SEO_US_BECOME_AUTHOR)
        FirstTouchTracking()
    });
    if (loginLinks.length) loginLinks.forEach(link => link.addEventListener('click', sendLoginEvent))
}

init()
